import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasValue } from 'globalutils/fmUtils';
import moment from 'moment';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const TableComponent = ({
  list,
  apiStatus,
  deleteData,
  callback,
  columns,
  apiIds,
  noAction,
  defaultSortBy,
  pagination,
  setPagination,
}) => {
  const i18n = useTranslation();
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;

  /* Create a popup starts */
  const [ModalListObject, setModalListObject] = useState(null);

  const generateRows = () => {
    const updatedList = list.filteredList.map((item) => {
      item.description = item.url ? <Link href={item.url}>{item.description}</Link> : item.description;
      item.date = moment(new Date(item.date)).format('MM/DD/YYYY HH:mm:ss');
      return item;
    });
    return updatedList;
  };

  const hasApiStatus = hasValue(apiStatus.status, 'api', apiIds.list);
  const information =
    hasApiStatus && hasApiStatus.errorMessage ? (
      <Message type="error" message={hasApiStatus.errorMessage} />
    ) : (
      i18n.t('No data available')
    );
  return (
    <>
      <Table
        type="client"
        defaultSortBy={defaultSortBy || { sortBy: checkServiceProvider('table_sortBy', SERVICE_PROVIDER, false), order: 'desc' }}
        title=""
        columns={[...columns]}
        data={generateRows()}
        emptyMessage={information}
        itemsPerPage={checkServiceProvider('table_itemsPerPage', SERVICE_PROVIDER, false)}
        actions={
          noAction
            ? []
            : [
                {
                  icon: (row) => {
                    return (
                      <Icon
                        src={mediaUrls?.deleteIcon}
                        onClick={() => {
                          setModalListObject({
                            content: () => (
                              <div className="deleteParent">
                                <div className="imageSection">
                                  <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                                </div>
                                <h2> {i18n.t('common.sureConfirm')} </h2>
                                <div className="deletePopupBtn">
                                  <div className="cancelBtn">
                                    <Button
                                      label={i18n.t('common.cancel')}
                                      type={'reset'}
                                      onClick={() => {
                                        setModalListObject(null);
                                      }}
                                    ></Button>
                                  </div>
                                  <div className="deletebtn">
                                    <Button
                                      label={i18n.t('common.deletePopup')}
                                      onClick={() => {
                                        deleteData({
                                          apiId: apiIds.delete,
                                          data: { data: { id: row.id } },
                                          callback: callback,
                                        });
                                        setModalListObject(null);
                                      }}
                                    ></Button>
                                  </div>
                                </div>
                              </div>
                            ),
                          });
                        }}
                      />
                    );
                  },
                },
              ]
        }
        i18n={i18n}
        pageinationReset={pagination}
        pagenationClicked={(e) => {
          setPagination(!e);
        }}
      />

      {ModalListObject && (
        <Modal open={!!ModalListObject} setOpen={() => setModalListObject(null)} data={ModalListObject} deletePopup />
      )}
    </>
  );
};

export default TableComponent;
